import { render, staticRenderFns } from "./Breads.vue?vue&type=template&id=7d5ee20a&scoped=true&"
import script from "./Breads.vue?vue&type=script&lang=js&"
export * from "./Breads.vue?vue&type=script&lang=js&"
import style0 from "./Breads.vue?vue&type=style&index=0&id=7d5ee20a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5ee20a",
  null
  
)

export default component.exports